import { MediaPathHelper } from '../helpers/media-path.helper';
import  normalize from 'json-api-normalize';
import { DrupalBaseModel } from './drupal-base.model';
import dayjs from 'dayjs';

export class VideoModel extends DrupalBaseModel {

  public static parseVideo(videoJson: any, originalSeriesData?, videoType?: string): VideoModel[] | VideoModel {

    let parsedData;
    if (videoType !== 'tours') {
      const data = normalize(videoJson).get([
        'name',
        'field_subtitle',
        'field_short_description',
        'field_media_oembed_video',
        'path',
        'drupal_internal__nid',
        'thumbnail',
        'field_duration_minutes',
        'field_published_date'
      ]);

      // Homepage video promo data does not come as an array, video series data does.
      if (data instanceof Array) {
        parsedData =  data.map((row, index)  => {
          return this.mapValues(row, index, videoJson);
        });
      } else {
        parsedData = this.mapValues(data);
      }
    } else {
      parsedData = this.mapToursValues(videoJson);
    }

    return parsedData;
  }

  private static mapToursValues (video, position = 0) {

    return new VideoModel({
      title: video.name,
      subtitle: video.field_subtitle ? video.field_subtitle : '',
      description: video.field_short_description ? video.field_short_description.processed : '',
      image: video.thumbnail.dataset.data.links.self.href,
      url: MediaPathHelper.youTubeEmbedUrl(video.field_media_oembed_video as string) + '?enablejsapi=1',
      cmsPath: video.path,
      nid: video.drupal_internal__nid,
      duration: video.field_duration_minutes,
      publishedDate: video.field_published_date ? dayjs(video.field_published_date).format('MMM DD YYYY') : '',
      seriesPosition: position + 1,
      uuid: video.id
    });
  }

  private static mapValues (video, position = 0, videoJson?) {

    return new VideoModel({
      title: video.name,
      subtitle: video.field_subtitle ? video.field_subtitle : '',
      description: video.field_short_description ? video.field_short_description.processed : '',
      image: video.thumbnail ? video.thumbnail.dataset.data.links.teaser.href : null,
      url: MediaPathHelper.youTubeEmbedUrl(video.field_media_oembed_video as string) + '?enablejsapi=1',
      cmsPath: video.path,
      nid: video.drupal_internal__nid,
      duration: video.field_duration_minutes,
      publishedDate: video.field_published_date ? dayjs(video.field_published_date).format('MMM DD YYYY') : '',
      seriesPosition: position + 1,
      uuid: video.id
    });
  }

  public title: string;
  public subtitle: string;
  public description: string;
  public image: string;
  public url: string;
  public duration: number;
  public publishedDate: string;
  public seriesPosition: number;
  public uuid: string;

  constructor(values?: Partial<VideoModel>) {
    super(values);
    Object.assign(this, values);
  }
}
